
import React, { useEffect, useState } from 'react'
import { SearchIcon, QuestionMarkCircleIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon } from "@heroicons/react/outline";
import Layout from "../../components/Layout/Layout";
import { Link } from "react-router-dom";
import ActionDropdown from "../../components/ActionDropdown";
import { Fragment } from 'react'
import Paginate from '../../utils/Paginate';
import { convert, formatDate, pascalCASE, DisplayTime } from './../../utils/convertDate';
import DatePicker from 'react-date-picker';
import BusinessServices from '../../services/BusinessServices';


function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}
const statusStyles = {
    Approved: 'bg-green-500 text-white',
    Rejected: 'bg-orange-600 text-white',
    Pending: 'bg-amber-400 text-white'
}

export default function BusinessAccounts() {
    const [accounts, setAccount] = useState([]);
    const [search, setSearch] = useState("")
    const [pageIndex, setPageIndex] = useState(1);
    const [prevPage, setPrev] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPage, setPage] = useState(0)
    const [nextPage, setNextPage] = useState(false)
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("")
    const [pageLength, setPageLength] = useState("");
    const oldFrom = new Date().setDate(new Date().getDate() - 7);
    const [formValues, setFormValues] = useState({
        from: new Date(oldFrom),
        to: new Date()
    })
    const defaultTo = formatDate(new Date());
    const longNew = formatDate(defaultTo);
    const [too, setToo] = useState(convert(longNew));
    const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
    const longDate = formatDate(defaultFrom);
    const [fromm, setFromm] = useState(convert(longDate));
    const [status, setStatus] = useState("");
    const [type, setType] = useState("");
    
const listBusinessAccount = async (search, from, to, type, status) => {
    
    const account = await BusinessServices.listBusinessAccount(pageIndex, 10, search, from, to, type, status);
    if(account){
        setAccount([...account?.data.result]);
        setPageLength([...account?.data.result].length)
        setPageNumber(account?.data.totalCount)
        setPageIndex(account?.data.pageIndex)
        setPrev(account?.data.hasPreviousPage);
        setPage(account?.data.totalPages)
        setNextPage(account?.data.hasNextPage)
    }
  
}

    const listAccount = async () => {
        listBusinessAccount(search, fromm, too, type, status);       
    }
    const searchAccount = async (text) => {
        setSearch(text);
    };
    const handleType = async (text) => {
        text = text === "All" ? "" : text;
        setType(text);
        listBusinessAccount( search, fromm, too, text, status);
            
    }

    const handleStatus = async (text) => {
        text = text === "All" ? "" : text;
        setStatus(text);
        listBusinessAccount(search, fromm, too, type, text);
       
    }
 
    const range = async (e) => {
        e.preventDefault();
        const newDate = formatDate(formValues.from)
        setFrom(formValues.from)
        var longDate = formatDate(newDate);
        setFromm(convert(longDate));

        const toDate = formatDate(formValues.to);
        setTo(formValues.to)
        setToo(convert(toDate));

        listBusinessAccount( search, convert(newDate), convert(toDate), type, status);
    }
 
    const dateValidation = {
        fromHandler: (event) => {
            setFormValues({ ...formValues, from: event })
        },
        toHandler: (event) => {
            setFormValues({ ...formValues, to: event })
        }
    };

    const handleExport = async () => {
        const resp = await BusinessServices.exportBusinessAccount(search, fromm, too, type, status);
        window.open(resp?.data);
    }
    useEffect(() => {
        listAccount();

    }, [pageIndex]);
    return (<>
        <Layout title="Business Accounts" pageTag={'account'} current={'/business/accounts'}>
            <React.Fragment>
                <main>
                    <div className='max-w-7xl mx-auto '>
                        <div className=''>
                            <div className="">
                                <div className="mt-5 sm:ml-16 flex justify-end">
                                    <button
                                        type="button"
                                        onClick={handleExport}
                                        className="mr-2 inline-flex active:text-white items-center justify-center rounded-md border border-transparent hover:text-white btn-green px-3 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                                    >
                                        <DocumentDownloadIcon className="w-4 mr-1.5" />
                                        Export CSV
                                    </button>
                                </div>
                                <div className="sm:flex sm:items-center">
                                    <div className="sm:flex-auto flex">
                                        <div className=" relative rounded-md shadow-sm ml-3">
                                            <p className='text-sm leading-3 text-gray-500'>From</p>
                                            <div>
                                                <DatePicker
                                                    onChange={dateValidation.fromHandler}
                                                    value={formValues.from} />
                                            </div>
                                        </div>
                                        <div className=" relative rounded-md shadow-sm ml-3">
                                            <p className='text-sm leading-3 text-gray-500'>To</p>
                                            <div>
                                                <DatePicker
                                                    onChange={dateValidation.toHandler}
                                                    value={formValues.to} />
                                            </div>
                                        </div>
                                        <div className='flex'>
                                            <div className='tooltip'>
                                                <div className="mt-5 ml-4 relative rounded-md shadow-sm">
                                                    <div className="absolute inset-y-0 left-0 pl-1 flex items-center pointer-events-none">
                                                        <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                                    </div>
                                                    <input
                                                        type="text"
                                                        name="user"
                                                        id="user"
                                                        onChange={(e) => searchAccount(e.target.value)}
                                                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-6 sm:text-sm border-gray-300 rounded-md"
                                                        placeholder="Search"
                                                    />
                                                    <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                                                        <div className='tooltip'>
                                                            <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                                                            <span className="tooltiptext"> <p>Search by email address, tin , rc number and first name</p></span>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                         <div className="mt-5 relative rounded-md shadow-sm ml-3">
                                            <select
                                                id="currency"
                                                name="currency"
                                                onChange={(e) => handleType(e.target.value)}
                                                placeholder="Filter by"
                                                className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2  border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                            >
                                                <option value={"All"}>Sort by type</option>
                                                <option value={"All"}>All</option>
                                                <option value={"Sole_Proprietorship"}>Sole Proprietorship</option>
                                                <option value={"Limited_Liability_Company"}>Limited Liability</option>
                                            </select>
                                        </div>
                                       
                                        <div className="mt-5 relative rounded-md shadow-sm ml-3">
                                            <select
                                                id="currency"
                                                name="currency"
                                                onChange={(e) => handleStatus(e.target.value)}
                                                placeholder="Filter by"
                                                className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2  border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                            >
                                                <option value={"All"}>Sort by document status</option>
                                                <option value={"All"}>All</option>
                                                <option value={"InComplete"}>InComplete</option>
                                                <option value={"Complete"}>Complete</option>
                                            </select>
                                        </div>
                                        <div className='mt-5 ml-4'>
                                            <button
                                                onClick={range}
                                                className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                                        </div>
                                    </div>
                                </div>
                                {accounts.length === 0 ?
                                    (
                                        <div className="mt-8"> No data available for these dates to show. </div>
                                    ) : <>
                                        <div className="mt-8 flex ">
                                            <div className="-my-2  overflow-x-auto ">
                                                <div className="inline-block min-w-full py-2 align-middle ">
                                                    <div className="relative h-screen  ring-black ring-opacity-5 md:rounded-lg">
                                                        <table className="min-w-full table-fixed divide-y divide-gray-300">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col" className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm text-gray-500">
                                                                        Business Owner Name
                                                                    </th>
                                                                    <th scope="col" className="min-w-[8rem]  py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        Business Owner Address
                                                                    </th>
                                                                    <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        FIRS Phone
                                                                    </th>

                                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        RC Number
                                                                    </th>
                                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        JTB
                                                                    </th>
                                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        TIN
                                                                    </th>
                                                                    <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        Business Account Status
                                                                    </th>
                                                                    <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        Business Category
                                                                    </th>
                                                                    <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        Industry Name
                                                                    </th>
                                                                    <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        Date Created
                                                                    </th>
                                                                    <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-500">
                                                                        Time Created
                                                                    </th>
                                                                    <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                        <span className="sr-only">Edit</span>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="divide-y divide-gray-200 bg-white">
                                                                {accounts?.map((person, i) => (
                                                                    <tr key={i} className="bg-gray-50">
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{pascalCASE(person?.businessOwnerFirstName)} {person?.businessOwnerLastName} </td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person?.address}</td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person?.firsphone}</td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person?.firsrcnumber}</td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person?.jtbtin}</td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person?.tin}</td>
                                                                        <td>
                                                                            <span className={classNames(statusStyles[person?.requestStatus], "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900")}>{person?.requestStatus}</span>
                                                                        </td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person?.businessCategory}</td>
                                                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person?.industryName}</td>
<td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{formatDate(person?.dateCreated)}</td>
                                                                     <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{DisplayTime(person?.dateCreated)}</td>
                                                                     <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6" value={person?.id}>
                                                                            <ActionDropdown
                                                                              items={[
                                                                                { label: "View Account", onClick: () => window.location.href = `/view/business?id=${person?.businessOwnerUserName}` },
                                                                              ]}
                                                                              dropdownWidth="w-40"
                                                                            />

                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <Paginate
                                            nextPage={nextPage}
                                            pageIndex={pageIndex}
                                            totalCount={pageNumber}
                                            totalPages={totalPage}
                                            prevPage={prevPage}
                                            setPageIndex={setPageIndex}
                                        />
                                    </>
                                }

                            </div>

                        </div>
                    </div>
                </main>



            </React.Fragment>
        </Layout>



    </>);
}